export enum RootRoute {
  init = "init",
  auth = "auth",

  /**
   * Esta ruta espera a que todos los resolve sean correctas para lanzar:
   * 1. Empresa/Establecimiento/Integración en la que se encuentra el usuario.
   * 2. Escucha a servidor ws.
   */
  enterprise = ":enterprise/:branch-office",
  common = "common",
}
